var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 68.25C55.1543 68.25 68.25 55.1543 68.25 39C68.25 22.8457 55.1543 9.75 39 9.75C22.8457 9.75 9.75 22.8457 9.75 39C9.75 55.1543 22.8457 68.25 39 68.25Z",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.264 51.9189L48.7194 41.7423C48.4347 41.5592 48.1114 41.4445 47.7749 41.4071L40.7976 40.4626C40.277 40.3879 39.7463 40.4879 39.2887 40.747C38.8311 41.0062 38.4723 41.4098 38.2687 41.8946L34.0945 51.2485C33.8982 51.6836 33.834 52.1667 33.9099 52.638C33.9857 53.1092 34.1982 53.5478 34.521 53.8993L40.2491 60.0845C40.5081 60.3691 40.6978 60.7096 40.8035 61.0796C40.9092 61.4495 40.928 61.8389 40.8585 62.2173L39.6702 68.2501",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8046 16.9407L17.0624 23.4001C16.8235 23.9735 16.8126 24.6165 17.0319 25.1977L20.5358 34.5211C20.6728 34.9097 20.9072 35.2567 21.2166 35.5288C21.526 35.8008 21.9001 35.9889 22.303 36.075L28.8233 37.4766C29.1852 37.5498 29.5251 37.7063 29.816 37.9337C30.1069 38.1612 30.3407 38.4532 30.4991 38.7868L31.6569 41.1938C31.8626 41.6008 32.1758 41.9437 32.5625 42.1854C32.9492 42.4271 33.3947 42.5583 33.8507 42.5649H37.9639",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4647 10.6946L49.2982 15.8133C49.5599 16.2946 49.654 16.8492 49.5657 17.3898C49.4774 17.9304 49.2118 18.4262 48.8107 18.7993L40.6147 26.2032C40.4774 26.3342 40.3238 26.4468 40.1576 26.5383L36.41 28.6102C36.0527 28.7998 35.6564 28.904 35.2521 28.9149H28.7318C28.2515 28.9173 27.7823 29.0599 27.3818 29.3251C26.9813 29.5903 26.6669 29.9666 26.4771 30.4079L23.9482 36.4102",
    stroke: "#BD1D83",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.1dec098f317f53fe2cefd02e60c94f7d.svg";
export { ForwardRef as ReactComponent };